/**
 * 08 — Sticky ATC
 * Cross-section JS contract (see .claude/BUILD_CONTRACT.md):
 *   - Show whenever `[data-reason-tag="Grund 3"]` (built by section _02) has
 *     scrolled above the viewport (its bottom edge < 0, no longer
 *     intersecting from below) AND `.acc-lp02-05` (the buy-box section)
 *     hasn't been reached yet from above (top/bottom still >= 0 or
 *     intersecting counts as "at" it, not "past" it).
 *   - This is a LIVE toggle, not a one-way latch: scrolling back up out of
 *     the buy box (or out of Trust Strip/FAQ) into the Grund-3..buy-box gap
 *     must bring the bar back, same as scrolling down into that gap the
 *     first time.
 *   - Both lookups are intentionally global (`document.querySelector`) since
 *     the watched elements live in other sections — guard for null so a
 *     removed section never throws, the bar just stays hidden.
 * Own DOM (the button) is scoped to this section's root only.
 */
(function () {
  'use strict';

  var bars = document.querySelectorAll('.acc-lp02-08');
  if (!bars.length) return;

  var reasonEl = document.querySelector('[data-reason-tag="Grund 3"]');
  var buyBoxEl = document.querySelector('.acc-lp02-05');

  // Per contract: if either anchor section is missing, stay hidden, never throw.
  if (!reasonEl || !buyBoxEl) return;

  var state = {
    pastReason: false,
    atBuyBox: false,
    pastBuyBox: false
  };

  function updateVisibility() {
    var shouldShow = state.pastReason && !state.atBuyBox && !state.pastBuyBox;
    for (var i = 0; i < bars.length; i++) {
      bars[i].classList.toggle('acc-lp02-08--visible', shouldShow);
    }
  }

  var reasonObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      // "Scrolled past" = no longer intersecting AND its bottom edge has
      // moved above the viewport top (i.e. out of view from below, not
      // simply not-yet-reached from above).
      state.pastReason = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
    });
    updateVisibility();
  }, { root: null, threshold: 0 });

  var buyBoxObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      state.atBuyBox = entry.isIntersecting;
      // Same "scrolled past" test as reasonObserver, applied to the buy box:
      // fully above the viewport, not just not-yet-reached.
      state.pastBuyBox = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
    });
    updateVisibility();
  }, { root: null, threshold: 0 });

  reasonObserver.observe(reasonEl);
  buyBoxObserver.observe(buyBoxEl);

  // Click: smooth-scroll to the buy box regardless of the theme's global
  // `scroll-behavior` setting — call scrollIntoView with an explicit
  // 'smooth' behavior so it animates either way.
  for (var i = 0; i < bars.length; i++) {
    (function (bar) {
      var btn = bar.querySelector('.acc-lp02-08__btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var target = document.querySelector('.acc-lp02-05');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    })(bars[i]);
  }
})();
